var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 6,
    viewBox: "0 0 5 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71438 2.29964H2.57146V2.72656C2.69492 2.48102 3.01154 2.26041 3.48715 2.26041C4.39892 2.26041 4.61538 2.74918 4.61538 3.64594V5.30679H3.69231V3.85018C3.69231 3.33948 3.56885 3.05148 3.25454 3.05148C2.81862 3.05148 2.63746 3.36187 2.63746 3.84994V5.30679H1.71438V2.29964ZM0.131538 5.26756H1.05462V2.26041H0.131538V5.26756ZM1.18685 1.27987C1.18688 1.35724 1.17154 1.43385 1.1417 1.50523C1.11187 1.57662 1.06815 1.64137 1.01308 1.69571C0.901477 1.80663 0.750418 1.86871 0.593077 1.86833C0.436013 1.86822 0.285302 1.8063 0.173538 1.69594C0.118664 1.64142 0.075089 1.5766 0.0453101 1.5052C0.0155311 1.4338 0.000133646 1.35723 0 1.27987C0 1.12364 0.0623077 0.974099 0.173769 0.863791C0.285435 0.753289 0.436209 0.691337 0.593308 0.691406C0.750692 0.691406 0.901615 0.753483 1.01308 0.863791C1.12431 0.974099 1.18685 1.12364 1.18685 1.27987Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.711e100c4672f4f51350809171b09a12.svg";
export { ForwardRef as ReactComponent };